import React, { useState, useEffect } from 'react';
import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import WaterDropIcon from '@mui/icons-material/Opacity';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ListItemButton from '@mui/material/ListItemButton';

import AccordionDetails from '@mui/material/AccordionDetails';
import CardContent from '@mui/material/CardContent';
import Card from '@mui/material/Card';

import Dialog from '@mui/material/Dialog';

function MapAccordion(props) {
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [teaTypeIndex, setTeaTypeIndex] = React.useState(0);

  const teaTypeInfo = [
    {
      "Type":"Oolong",
      "Oxidation": "20-80%",
      "Feature": "RouNian, Baking",
    },
    {
      "Type":"Dark",
      "Oxidation": "100%",
      "Feature": "Heap Fermentation",
    },
    {
      "Type":"White",
      "Oxidation": "20%",
      "Feature": "Sun Drying",
    },
    {
      "Type":"Green",
      "Oxidation": "20%",
      "Feature": "RouNian, Baking",
    },
    {
      "Type":"Red (Black)",
      "Oxidation": "80%",
      "Feature": "RouNian, Baking",
    },
    {
      "Type":"Yellow",
      "Oxidation": "20%",
      "Feature": "RouNian, Baking",
    },
  ]; 

	return (
        <Accordion
        expanded={props.expanded === props.panelId}
        onChange={(e, isExpanded) => props.handleChange(props.panelId, isExpanded, e.target.id)}
        // onChange={(e) => console.log(e.target.id)}
         disableGutters
        >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography sx={{ width: '60%', flexShrink: 0 }}>
            <b>{props.summary}</b>
          </Typography>
          <WaterDropIcon sx={{color:props.dropColor, mr:2}} />
          <InfoOutlinedIcon id="infoIcon" sx={{color:"gray"}}
          onClick={() => setDialogOpen(true)} />
        </AccordionSummary>
        <AccordionDetails>
        <List sx={{mt:'0px'}}  disablePadding dense>

        {props.teas.map((value, index) => {
          return (
            <ListItem disablePadding>
            
            {/* <ListItemButton onClick={() => setTeaType("PuErh")}>  */}
              <ListItemButton onClick={() => props.handleSelect(value.region, value.index)}> 
                <ListItemText primary={value.name} secondary={value.region} />
              </ListItemButton>
              
            </ListItem>
          )
        })}
        </List>

        <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}> 
          <Card sx={{minWidth: 300, height: 300}}>
            <CardContent>
              <Typography variant="h6">
                {teaTypeInfo[props.typeIndex]["Type"]}
              </Typography>
              
            </CardContent>
          </Card>
        </Dialog>

        </AccordionDetails>
      </Accordion>
	)
}

export default MapAccordion;